<template>
    <div class="wallet-list-box">
        <div class="wallet-opration">
            <el-select v-model="selectStatus">
                <el-option v-for="item in statusList" :label="item.label" :value="item.value"
                           :key="item.id"></el-option>
            </el-select>
            <el-autocomplete class="inline-input"
                             v-model="queryParams.coinType"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入币种">
                <i class="el-icon-close el-input__icon" slot="suffix"
                   @click="cleanSearchCoin" style="cursor:pointer;">
                </i>
            </el-autocomplete>
            <el-date-picker
                    v-model="dateArr"
                    value-format="timestamp"
                    type="datetimerange"
                    @change="dateChange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
            </el-date-picker>
            <el-button style="margin-left: 10px" type="danger" @click="searchData">搜索</el-button>
            <el-button style="margin-left: 10px" icon="el-icon-plus" type="danger" @click="reconciliation">重新对账
            </el-button>
            <el-button style="float: right" type="danger" @click="exportData">导出数据</el-button>
        </div>
        <div class="wallet-list">
            <el-table class="wallet-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletUserAmount" label="用户钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletWithAmount" label="提现钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletColdAmount" label="冷钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletCoboAmount" label="cobo钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletSafeAmount" label="safe钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletBufferAmount" label="缓冲钱包余额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="userDepoAmount" label="用户充值金额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="userWithAmount" label="用户提现金额" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalAmount" label="物理钱包总金额" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dbDifference" label=" 用户充提差值" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletDifference" label="钱包余额差值" width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip width="250">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==-1">对账异常</span>
                        <span v-if="scope.row.status==0">对账成功</span>
                        <span v-if="scope.row.status==1">账目可控</span>
                        <span v-if="scope.row.status==2">账目危险</span>
                        <span v-if="scope.row.status==3">对账失败,钱包余额大于数据库金额</span>
                        <span v-if="scope.row.status==4">对账失败,钱包金额小于数据库金额</span>
                    </template>
                </el-table-column>
                <el-table-column prop="comments" label=" 详情" show-overflow-tooltip width="300"></el-table-column>
                <el-table-column label="开始时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.beginTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.endTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.createdTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :visible.sync="dialogVisible" @close="closeDialog" @open="openDialog" title="支持手动对账的币种" width="1200px">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkCoinList" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="(info,index) in coinList" :label="info" :key="index"
                             style="width: 150px;margin-left: 0px;overflow: hidden;margin-bottom: 5px">{{info}}
                </el-checkbox>
            </el-checkbox-group>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取 消</el-button>
                <el-button plain type="danger" @click="saveNeedReconciliationCoin">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: "walletAccount",
        data() {
            return {
                checked: false,
                dataList: [],
                total: 0,
                queryParams: {
                    coinType: "",
                    status: "",
                    startTime: "",
                    endTime: "",
                    page: 1,
                    size: 10,
                },
                dialogVisible: false,
                coinTypes: [],
                dateArr: [],
                statusList: [
                    {id: 1, value: -2, label: '全部'},
                    {id: 2, value: -1, label: '对账异常'},
                    {id: 3, value: 0, label: '对账成功'},
                    {id: 4, value: 1, label: '账目可控'},
                    {id: 5, value: 2, label: '账目危险'},
                    {id: 6, value: 3, label: '对账失败,钱包余额大于数据库金额'},
                    {id: 7, value: 4, label: '对账失败,钱包金额小于数据库金额'}
                ],
                selectStatus: -2,
                coinList: [],
                isIndeterminate: true,
                checkCoinList: [],
                checkAll: false
            }
        },
        methods: {
            reconciliation() {
                this.dialogVisible = true;
            },
            saveNeedReconciliationCoin(){
              api.saveNeedReconciliationCoin(this.checkCoinList).then((response) => {
                this.dialogVisible = false;
                this.$notify({
                  title: '保存成功',
                  message: response.data,
                  duration: 0,
                  type: 'success'
                });
              })
            },
            dateChange() {
                this.queryParams.startTime = this.dateArr != null ? this.dateArr[0] : null;
                this.queryParams.endTime = this.dateArr != null ? this.dateArr[1] : null;
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            searchData() {
                this.queryParams.page = 1;
                this.getWalletReconciliationList(this.queryParams);
            },
            exportData() {
                this.queryParams.page = 1;
                api.exportWalletReconciliationList(this.queryParams).then((response) => {
                    const fileName = "钱包对账信息.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                });
            },
            getWalletReconciliationList(param) {
                this.queryParams.status = this.selectStatus;
                if (this.selectStatus == -2) {
                    this.queryParams.status = null;
                }
                api.queryWalletReconciliationList(param).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getWalletReconciliationList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getWalletReconciliationList(this.queryParams);
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            handleCheckAllChange(val) {
                this.checkCoinList = val ? this.coinList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = this.checkCoinList.length;
                this.checkAll = checkedCount === this.coinList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.coinList.length;
            },
            closeDialog() {
                this.coinList = [];
                this.checkCoinList = [];
                this.isIndeterminate = true;
                this.checkAll = false;
                this.dialogVisible = false;
            },
            openDialog() {
                api.getAllSupportReconciliationCoin().then(({data}) => {
                    this.coinList = data;
                });
            },
            addRecord(){
                console.log(this.checkCoinList)
            }
        },
        created() {
            this.getWalletReconciliationList(this.queryParams);
            this.getAllSupportCoin();
        }
    }
</script>

<style lang="less" scoped>
    .wallet-list-box {

        .wallet-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .wallet-table {
                margin-top: 30px;
            }
        }
    }
</style>
